import './attorneys_section_style.scss';
import Slider from "react-slick";
import AttorneyImage1 from './../../assets/img_attorney_1.png';
import AttorneyImage2 from './../../assets/img_attorney_2.png';
import AttorneyImage3 from './../../assets/img_attorney_3.png';
import { useRef } from 'react';
import { removeBaseUrl } from '../../utils';
import { Link } from 'react-router-dom';
const CustomPrevArrow = (props) => {
    return (
        <span {...props} className="slick-arrow arrow-prev">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.7342 18.3455L18.1212 24.7329L19.4585 23.3956L15.3795 19.3167L24.9194 19.3167L24.9194 17.3369L15.3795 17.3369L19.4585 13.258L18.1212 11.9207L11.7342 18.3455ZM0.827026 18.3144C0.827026 15.8972 1.28574 13.6245 2.20317 11.4963C3.1206 9.36847 4.36565 7.51742 5.9383 5.94315C7.51095 4.36889 9.36038 3.12271 11.4866 2.20463C13.6125 1.28623 15.8842 0.827025 18.3018 0.827026C20.719 0.827026 22.9917 1.28574 25.1199 2.20318C27.2477 3.12061 29.0988 4.36565 30.6731 5.9383C32.2473 7.51095 33.4935 9.36038 34.4116 11.4866C35.33 13.6125 35.7892 15.8842 35.7892 18.3018C35.7892 20.719 35.3305 22.9917 34.413 25.1199C33.4956 27.2477 32.2506 29.0988 30.6779 30.6731C29.1053 32.2473 27.2558 33.4935 25.1296 34.4116C23.0037 35.33 20.732 35.7892 18.3144 35.7892C15.8972 35.7892 13.6245 35.3305 11.4963 34.413C9.36847 33.4956 7.51742 32.2506 5.94315 30.6779C4.36889 29.1053 3.12271 27.2558 2.20463 25.1296C1.28623 23.0037 0.827025 20.732 0.827026 18.3144ZM2.76937 18.3081C2.76937 22.646 4.27468 26.3203 7.28531 29.3309C10.2959 32.3415 13.9702 33.8468 18.3081 33.8468C22.646 33.8468 26.3203 32.3415 29.3309 29.3309C32.3415 26.3203 33.8468 22.646 33.8468 18.3081C33.8468 13.9702 32.3415 10.2959 29.3309 7.28531C26.3203 4.27468 22.646 2.76937 18.3081 2.76937C13.9702 2.76937 10.2959 4.27468 7.28531 7.28531C4.27468 10.2959 2.76937 13.9702 2.76937 18.3081Z" fill="#2E5A88"/>
            </svg>
        </span>
    );
};
  
const CustomNextArrow = (props) => {
    return (
        <span {...props} className="slick-arrow arrow-next">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.882 18.2707L18.4951 11.8833L17.1578 13.2206L21.2367 17.2995L11.6969 17.2995L11.6969 19.2793L21.2367 19.2793L17.1578 23.3582L18.4951 24.6955L24.882 18.2707ZM35.7892 18.3018C35.7892 20.719 35.3305 22.9917 34.413 25.1199C33.4956 27.2477 32.2506 29.0988 30.6779 30.6731C29.1053 32.2473 27.2558 33.4935 25.1296 34.4116C23.0037 35.33 20.732 35.7892 18.3144 35.7892C15.8972 35.7892 13.6245 35.3305 11.4963 34.413C9.36847 33.4956 7.51742 32.2506 5.94315 30.6779C4.36889 29.1053 3.12271 27.2558 2.20463 25.1296C1.28623 23.0037 0.827027 20.732 0.827027 18.3144C0.827027 15.8972 1.28574 13.6245 2.20318 11.4963C3.12061 9.36847 4.36565 7.51742 5.9383 5.94316C7.51095 4.36889 9.36038 3.12271 11.4866 2.20463C13.6125 1.28623 15.8842 0.827027 18.3018 0.827027C20.719 0.827027 22.9917 1.28574 25.1199 2.20317C27.2477 3.12061 29.0988 4.36565 30.6731 5.9383C32.2473 7.51095 33.4935 9.36038 34.4116 11.4866C35.33 13.6125 35.7892 15.8842 35.7892 18.3018ZM33.8468 18.3081C33.8468 13.9702 32.3415 10.2959 29.3309 7.28531C26.3203 4.27468 22.646 2.76937 18.3081 2.76937C13.9702 2.76937 10.2959 4.27468 7.28531 7.28531C4.27468 10.2959 2.76937 13.9702 2.76937 18.3081C2.76937 22.646 4.27468 26.3203 7.28531 29.3309C10.2959 32.3415 13.9702 33.8468 18.3081 33.8468C22.646 33.8468 26.3203 32.3415 29.3309 29.3309C32.3415 26.3203 33.8468 22.646 33.8468 18.3081Z" fill="#2E5A88"/>
            </svg>
        </span>    
    );
};

const sliderSettings = {
    centerMode: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: false,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
            slidesToShow: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
            slidesToShow: 2,
        }
      },
      {
        breakpoint: 460,
        settings: {
            slidesToShow: 1,
        }
      }
    ]
}

export const AttorneysSection = ({
    fields
}) => {

    return <section id="attorney-section" className="home-section">
        <div className="container">
            <div className='inner-wrapper'>
                <div className='block-left-section'>
                    <h3>{ fields?.attorneys_section_pre_title ?? 'Who we are'}</h3>
                    <h2>{ fields?.attorneys_section_title ?? 'About Us'}</h2>
                    <div className='block-content' dangerouslySetInnerHTML={{ __html: fields?.attorneys_intro_details }} ></div>
                </div>
                <div className='block-right-section'>
                    <div className='attorneys-wrapper'>
                        <Slider {...sliderSettings} className='attorneys-repeater'>
                            {
                                fields?.attorneys_repeater?.map((it, index) => <div className='block-attorney' key={index}>
                                    <img src={it?.block_image} />
                                    <Link to={removeBaseUrl(it?.block_url)} />
                                </div>)
                            }
                        </Slider>
                    </div>
                </div>
            </div>
       </div>
    </section>
}